import { useMutation } from '@debbie/common/dist/util/hooks.js';
import React, { useEffect, useState } from 'react';
import Errors from './Errors.js';
/**
 * Persists a picked id as soon as it changes, showing the new value while the
 * save runs and falling back to the saved one if it fails
 */
const GenericSelector = (props) => {
    const [id, setId] = useState(props.id);
    useEffect(() => {
        if (props.id !== id) {
            setId(props.id);
        }
    }, [props.id]);
    const model = useMutation(props.mutationFn, {
        onError: () => {
            setId(props.id);
        },
        onSuccess: () => {
            if (props.onSuccess) {
                props.onSuccess();
            }
        },
    });
    const update = (id) => {
        setId(id);
        model.reset();
        model.mutate(id);
    };
    return (React.createElement(React.Fragment, null,
        model.isError && model.error instanceof Error ? (React.createElement(Errors, { errors: [model.error.message] })) : null,
        props.children({
            value: id,
            onChange: update,
            disabled: model.isLoading,
        }),
        props.preview && props.preview(id)));
};
export default GenericSelector;
//# sourceMappingURL=GenericSelector.js.map